import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#FFCE6E',
        secondary: '#800000',
        accent: '#800000',
        error: '#b71c1c',
      }
    }
  }
});
